import State from 'renderer/Global/State/State';
import Transaction from '../History/Transaction/Transaction';

export function updateCompendium(
  playerState: State,
  itemID: string | number | boolean | Transaction
) {
  let playerCompendium = playerState.compendium;
  let playerCompendiumArr = playerState.compendiumArr;

  if (typeof itemID === 'number') {
    if (
      (!playerCompendium.size || !playerCompendium.has(itemID)) &&
      itemID > 0
    ) {
      playerCompendium.set(itemID, true);
      playerCompendiumArr.push(itemID)
    }
  }

  return playerCompendium;
}
